import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Edge } from '../edge/edge.model';
import { api } from '@consts/url.const';

export interface GetUnSyncedEdgesDto {
  orgId?: string;
  from?: number;
  to?: number;
  onlineOnly?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SyncQueueService {
  constructor(private http: HttpClient) {}

  getLastCommittedOperations(edgeId: string, page = 0, size = 50): Observable<Edge.PaginatedSyncQueueResponse> {
    return this.http.get<Edge.PaginatedSyncQueueResponse>(api.edgeSyncQueue.lastCommitted + `?edgeId=${edgeId}&page=${page}&size=${size}`);
  }

  getNextOperations(edgeId: string, page = 0, size = 50): Observable<Edge.PaginatedSyncQueueResponse> {
    return this.http.get<Edge.PaginatedSyncQueueResponse>(api.edgeSyncQueue.nextOperation + `?edgeId=${edgeId}&page=${page}&size=${size}`);
  }

  retryOperation(edgeId: string, edgeLogId: string): Observable<any> {
    return this.http.post(api.edgeSyncQueue.publishOperation, null, {
      params: { edgeId, edgeLogId }
    });
  }

  isEdgeSyncForOrg(): Observable< Edge.EdgeSyncRes[]> {
    return this.http.get<Edge.EdgeSyncRes[]>(api.edgeSyncQueue.orgSync );
  }

  cancelOperation(edgeId: string, edgeLogId: string): Observable<any> {
    return this.http.post(api.edgeSyncQueue.cancelOperation, null, {
      params: { edgeId, edgeLogId }
    });
  }

  resetPublishCounter(edgeId: string, edgeLogId: string): Observable<any> {
    return this.http.post(api.edgeSyncQueue.resetPublishCounter, null, {
      params: { edgeId, edgeLogId }
    });
  }

  validateEdgeSync(edgeId: string): Observable<Edge.EdgeSyncValidation> {
    return this.http.get<Edge.EdgeSyncValidation>(api.edgeSyncQueue.validateSync, {
      params: { edgeId }
    });
  }

  getErrorOrSkippedOperations(edgeId: string, page = 0, size = 50): Observable<Edge.PaginatedSyncQueueResponse> {
    return this.http.get<Edge.PaginatedSyncQueueResponse>(api.edgeSyncQueue.errorOrSkipped + `?edgeId=${edgeId}&page=${page}&size=${size}`);
  }

  getAllUnSyncedEdgesCommands(filters: GetUnSyncedEdgesDto, page = 0, size = 50): Observable<Edge.PaginatedSyncQueueResponse> {
    return this.http.post<Edge.PaginatedSyncQueueResponse>(`${api.edgeSyncQueue.unSyncedEdges}`, { ...filters, page, size });
  }
}
